import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../../vme-common.module';
import { VMEComponentsModule } from '../../../vme-components.module';
import { VmeDirectivesModule } from '../../../vme-directives.module';
import { VmePipesModule } from '../../../vme-pipes.module';
import { NewUserComponent } from './new-user.component';

const routes: Routes = [{ path: '', component: NewUserComponent, data: { title: 'New User' } }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class NewUserRoutingModule {}

@NgModule({
  imports: [
    NewUserRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [NewUserComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class NewUserModule {}
